import React from 'react';
import { Snackbar, Alert, Stack } from '@mui/material';
import { useNotifications } from './NotificationContext';

/**
 * NotificationDisplay - Component to display notifications
 */
const NotificationDisplay = () => {
  const { notifications, removeNotification } = useNotifications();

  // Handle closing a notification
  const handleClose = (id) => (event, reason) => {
    if (reason === 'clickaway') return;
    removeNotification(id);
  };

  return (
    <Stack spacing={2} sx={{ position: 'fixed', zIndex: 2000, width: '100%' }}>
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          anchorOrigin={notification.position}
          onClose={handleClose(notification.id)}
          sx={{ width: notification.width || 'auto', borderRadius: '30px' }}
          TransitionProps={{ appear: true }}
        >
          <Alert
            onClose={() => removeNotification(notification.id)}
            severity={notification.severity}
            variant="filled"
            sx={{ width: '100%', boxShadow: 5 }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default NotificationDisplay;